import React, { useState } from 'react';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';
import NumericInput from '@common/components/numericInput';
import { PredifinedAmounts } from './predifinedAmounts';
import ToastWrapper from '@common/helpers/toastWrapper';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { POPUPS } from '@common/constants/popups';
import { getAuthData } from '@common/helpers/auth';

export const MpesaDeposit = ({ openPopup, closePopup }) => {
  const t = useTranslation();
  const [amount, setAmount] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { currency } = getAuthData()

  const onDeposit = async () => {
    try {
      setIsLoading(true);

      const req = {
        amount: +amount,
        service: 475,
        payer: {
          forProduct: 'sport',
          isAmountHidden: false
        },
      }

      const res = await swarmRequest(req, 'deposit_v2');

      if (res.status === 'error')
        return ToastWrapper('error', res.message || 'Something went wrong while doing a deposit')

      openPopup(POPUPS.DEPOSIT_PENDING, { type: 'deposit' });
    } catch (ex) {
      ToastWrapper('error', 'Something went wrong while depositing')
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="popup-content popup-small mpesa-deposit-popup">
      <i onClick={closePopup} className="global-icon icon-Close close-popup" />
      <h3 className="popup-title">{t('M-Pesa Deposit')}</h3>
      <p className='popup-subtitle'>{t('Please input the deposit amount')}</p>
      <div className="popup-main-content">
        <i className='global-icon icon-mpesa-deposit' />
        <div className='input-wrapper'>
          {
            amount && <p className="popup-txt">{t('Deposit amount')}</p>
          }
          <div className='input-row'>
            <NumericInput
              value={amount}
              placeholder={t('Deposit amount')}
              onChange={setAmount}
              class="popup-inp"
              disableSearchIcon
            />
            <div className='input-right-content'>
              <span className='currency'>{currency}</span>
            </div>
          </div>
        </div>
        <PredifinedAmounts onSelect={setAmount} value={amount} />
      </div>
      <div className="popup-actions">
        <button
          className="popup-confirm-button"
          disabled={!+amount || isLoading}
          onClick={onDeposit}
        >
          {
            t(isLoading ? 'Processing...' : 'Deposit')
          }
        </button>
      </div>
    </div>
  )
}